<template>
  <!-- 代理店担当者登録ダイアログ -->
  <div>
    <v-btn class="info font-weight-bold" @click="showDialog"
      ><v-icon left>mdi-plus-box</v-icon
      ><span class="d-none d-sm-flex">新規登録</span
      ><span class="d-sm-none">新規</span></v-btn
    >
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      width="100%"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">代理店担当者設定</span>
        </v-card-title>
        <v-card-text class="scrollable-content">
          <input type="hidden" v-model="item.id" />
          <ValidationObserver ref="observer">
            <h3 id="title_head">基本情報</h3>
            <div class="mt-2 mb-2">
              代理店担当者に関する情報を設定して下さい。
            </div>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="6">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="担当者名"
                    rules="required|max:255"
                  >
                    <v-text-field
                      v-model="item.name"
                      name="name"
                      :error-messages="errors"
                      :success="valid"
                      label="担当者名"
                      hint="担当者名を入力してください[必須項目]"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="電話番号"
                    rules="max:50"
                  >
                    <v-text-field
                      v-model="item.tel"
                      name="tel"
                      :error-messages="errors"
                      :success="valid"
                      label="電話番号"
                      hint="電話番号を入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="メールアドレス"
                    rules="email|max:255"
                  >
                    <v-text-field
                      v-model="item.email"
                      name="email"
                      :error-messages="errors"
                      :success="valid"
                      label="メールアドレス"
                      hint="メールアドレスを入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="メモ"
                    rules="max:1000"
                  >
                    <v-text-field
                      v-model="item.note"
                      name="note"
                      :error-messages="errors"
                      :success="valid"
                      label="メモ"
                      hint="担当者に関するメモを入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row justify="end">
              <v-col cols="6" sm="3">
                <general-button
                  btn_color="gray"
                  btn_block
                  @click-event="cancelDialog"
                  ><template v-slot:icon
                    ><v-icon left>mdi-close-circle</v-icon></template
                  >キャンセル</general-button
                >
              </v-col>
              <v-col cols="6" sm="3">
                <general-button
                  btn_type="info"
                  btn_block
                  @click-event="onSubmit"
                  ><template v-slot:icon
                    ><v-icon left>mdi-content-save</v-icon></template
                  >保存</general-button
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { reactive, toRefs, defineComponent } from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";

export default defineComponent({
  props: ["agency_id"],
  setup(props, ctx) {
    const agencyContactsRepository = repositoryFactory.get("agencyContacts");
    const state = reactive({
      dialog: false, // ダイアログ表示用
      item: {
        id: 0,
        agency_id: 0,
        name: "",
        tel: "",
        email: "",
        note: "",
      },
    });

    // 新規作成
    const showDialog = async () => {
      await store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // ダイアログ開く
      state.dialog = true;

      // ローディング非表示
      await store.dispatch("loadingIcon/hideIcon");
    };

    const clearDialog = async () => {
      // 各種項目初期化
      state.item.id = 0;
      state.item.agency_id = Number(props.agency_id);
      state.item.name = "";
      state.item.tel = "";
      state.item.email = "";
      state.item.note = "";
    };

    const editDialog = async (agencyContactId) => {
      await agencyContactsRepository
        .admin_get(agencyContactId)
        .then((response) => {
          if (response.data) {
            // データ取得OK
            state.item.id = response.data.id;
            state.item.agency_id = response.data.agency_id;
            state.item.name = response.data.name;
            state.item.tel = response.data.tel || "";
            state.item.email = response.data.email || "";
            state.item.note = response.data.note || "";
          }
        })
        .catch((error) => {
          throw (
            "ERROR:agencyContactDialogComponent.vue/editDialog agencyContactsRepository.admin_get (" +
            error +
            ")"
          );
        });
      state.dialog = true;
    };

    // 保存処理
    const onSubmit = async () => {
      // 入力チェック エラー状態の部品が無いか調べる
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        // エラー処理
        return;
      }

      if (!window.confirm("保存してよろしいですか？")) {
        return false;
      }
      // ローディング表示
      store.dispatch("loadingIcon/showIcon");

      // 保存処理
      const params = {
        id: state.item.id,
        agency_id: state.item.agency_id,
        name: state.item.name,
        tel: state.item.tel,
        email: state.item.email,
        note: state.item.note,
        is_active: true,
      };

      // 新規か更新か
      if (state.item.id == 0) {
        // 新規
        await agencyContactsRepository
          .admin_create(params)
          .then((response) => {
            if (response.data) {
              // データ追加OK
              state.item.id = response.data.id; // idをセット
              ctx.refs.observer.reset(); // 入力エラー表示クリア
            }
          })
          .catch((error) => {
            throw (
              "ERROR:agencyContactDialogComponent.vue/onSubmit agencyContactsRepository.admin_create (" +
              error +
              ")"
            );
          });
      } else {
        // 更新
        await agencyContactsRepository
          .admin_update(params)
          .then((response) => {
            if (response.data) {
              // データ更新OK
              ctx.refs.observer.reset(); // 入力エラー表示クリア
            }
          })
          .catch((error) => {
            throw (
              "ERROR:agencyContactDialogComponent.vue/onSubmit agencyContactsRepository.admin_update (" +
              error +
              ")"
            );
          });
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");

      cancelDialog();

      ctx.emit("updated", params);
    };

    // ダイアログキャンセルボタン
    const cancelDialog = () => {
      state.dialog = false;
      ctx.refs.observer.reset(); // 入力エラー表示クリア
      clearDialog();
    };

    const init = async () => {
      // 初期化
      clearDialog();
    };

    init();

    // 返却オブジェクト定義
    return {
      setting,
      ...toRefs(state),
      editDialog,
      onSubmit,
      cancelDialog,
      showDialog,
    };
  },
});
</script>

<style scoped></style>
